module.exports = __webpack_public_path__ + "static/media/Piercing-ear-tragus.e8247893.png";